import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  ButtonProps,
  Dialog,
  DialogClose,
  DialogContent,
} from '@sib/ui';

type ActionButtonProps = ButtonProps & { label?: string };

interface ConfirmationDialogProps extends PropsWithChildren {
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  open?: boolean;
  loading?: boolean;
  CancelButtonProps?: ActionButtonProps;
  ConfirmButtonProps?: ActionButtonProps;
}

export const ConfirmationDialog = ({
  onClose,
  onConfirm,
  children,
  title,
  CancelButtonProps = {},
  ConfirmButtonProps = {},
  loading = false,
  open = false,
}: ConfirmationDialogProps) => {
  const { t } = useTranslation();
  const { label: cancelLabel, ...cancelButtonProps } = CancelButtonProps;
  const { label: confirmLabel, ...confirmButtonProps } = ConfirmButtonProps;

  return (
    <Dialog open={open} onOpenChange={isOpen => !isOpen && onClose()}>
      <DialogContent className="flex max-w-[95vw] flex-col items-center justify-center gap-7 rounded-lg bg-white p-7 text-center sm:max-w-[727px] sm:min-w-[520px]">
        {title && <h4 className="text-primary">{title}</h4>}
        {typeof children === 'string' ? (
          <p className="text-primary text-sm">{children}</p>
        ) : (
          children
        )}
        <div className="flex justify-center gap-4">
          <DialogClose asChild>
            <Button disabled={loading} variant="outline" {...cancelButtonProps}>
              {cancelLabel || t('cancel')}
            </Button>
          </DialogClose>
          <DialogClose asChild>
            <Button
              loading={loading}
              onClick={onConfirm}
              {...confirmButtonProps}
            >
              {confirmLabel || t('confirm')}
            </Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};
